const micrositeSettingDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
};

const micrositeSettingReducer = (state = micrositeSettingDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MICROSITE_SETTING':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MICROSITE_SETTING_SUCCESS':
      return {
        ...state,
        data: action.micrositeSetting,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_CREATE_MICROSITE_SETTING':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'CREATE_MICROSITE_SETTING_SUCCESS':
      return {
        ...state,
        data: action.micrositeSetting,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Microsite setting created',
      };
    case 'START_MICROSITE_SETTING_UPDATE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'MICROSITE_SETTING_UPDATE_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.micrositeSetting
        },
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Microsite setting updated',
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default micrositeSettingReducer;